export enum UserRole {
  CLIENT = "cliente",
  SUPPLIER = "suplidor",
  SELLER = "vendedor",
  GUARANTEER = "garantizador",
  MECHANIC = "mecanico",
  ADMIN = "admin",
}

export enum UserLevel {
  BRONZE = "Bronce",
  SILVER = "Plata",
  GOLD = "Oro",
  PLATINUM = "Platino",
  DIAMOND = "Diamante",
}

export interface UserData {
  id: string;
  uid?: string;
  email?: string | null;
  displayName?: string | null;
  firstName?: string;
  lastName?: string;
  phone?: string;
  role: UserRole | string;
  photoURL?: string | null;
  level?: UserLevel;
  createdAt?: unknown;
  updatedAt?: unknown;
  [key: string]: unknown;
}
